<div class="content-container">
  <div class="text-container">
    <h1>{{introHeader}}</h1>

    <p>{{introText}}</p>

    <button id='watchStories' (click)="onPlay()" [ngClass]="{'btn btn-outline-primary btn-outline left-button left-svg hover': true, 'active': !activeNext}">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <defs>
          <path id="a" d="M0 0h24v24H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="#FFF" d="M4 19.452V4.546a2 2 0 0 1 2.986-1.74l13.15 7.453a2 2 0 0 1 0 3.48l-13.15 7.453A2 2 0 0 1 4 19.452z" />
        </g>
      </svg>
      <span>WATCH</span>
    </button>
    @if (endOfLastVideo) {
      <button id='nextStories' (click)="onGoToComplateModule()" class="btn btn-outline-primary btn-outline hover active">NEXT</button>
    }
  </div>
  <div class="video-container " [ngClass]="{'fullScreen': underPlay}">
    <div class="videobg">
      <div class="videobg-width">
        <div class="videobg-aspect">
          <div id="video-with-controls" class="videobg-make-height">
            <div class="video-wrapper videobg-hide-controls">
            </div>
            <div class="play-next-wrapper hide grad">
              <div class="play-next">
                <svg (click)="onPlay()" xmlns="http://www.w3.org/2000/svg" width="96" height="96" style="background:transparent"
                  viewBox="0 0 96 96">
                  <g fill="none" fill-rule="evenodd">
                    <path d="M0 0h96v96H0z" />
                    <path fill="#FFF" d="M32 20v56l44-28z" />
                  </g>
                </svg>
              </div>
            </div>
            <div class="absolute-divs controls-container">
              <div class="controls-group">
                @if (!underPlay) {
                  <button type="button" class="btn btn-link svg-bg play" (click)="onPlay()"></button>
                }
                @if (underPlay) {
                  <button type="button" class="btn btn-link svg-bg pause" (click)="onPause()"></button>
                }
                @if (!OnCaption) {
                  <button title="Turn subtitles on" aria-label="Turn subtitles on" type="button" class="btn btn-link svg-bg offsubtitles" (click)="OnSubtitles()"></button>
                }
                @if (OnCaption) {
                  <button title="Turn subtitles off" aria-label="Turn subtitles off" type="button" class="btn btn-link svg-bg onsubtitles" (click)="OffSubtitles()"></button>
                }
                @if (current > 5) {
                  <button type="button" class="btn btn-link svg-bg backward" (click)="onBackward()"></button>
                }
                @if (isBeta) {
                  <button type="button" class="btn btn-link svg-bg forward" (click)="onForward()"></button>
                }
              </div>
              <div class="time-group">
                <div class="max">{{ duration | secondsToTime }}</div>
                <div class="separator">|</div>
                <div class="current">{{ current | secondsToTime }}</div>
              </div>
              <div class="clearfix"></div>
              <div class="progress-group">
                <div class="played" (click)="onClickProgress($event)" [ngStyle]="{width: progressValue + '%'}"></div>
                <div class="current" [ngStyle]="{left: progressValue + '%'}"></div>
                <div class="unplayed" [ngStyle]="{width: (100 - progressValue) + '%'}"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<app-progress-bar [progressValue]=courseProgress></app-progress-bar>
